import axios from './axiosInstances/axiosInstance';

export const checkOrderStatus = (orderId) => {
  return axios.get(`/orders/${orderId}`);
};
